import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, breakpoints } from '@styles/index';
import { getIsDarkModeOn } from '@stores/selectors/darkModeStatusSelectors';
import useDarkModeStatus from '@stores/useDarkModeStatus';

const StyledPlusCourseCard = styled.div`
  background-color: var(--color-base-1);
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  overflow: hidden;
  grid-column: span 6;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    grid-column: span 11;
  }
`;

const StyledSkeleton = styled(Skeleton)`
  @media only screen and (max-width: ${breakpoints.mobile}) {
    &.thumbnail {
      width: 100% !important;
    }
  }
  ${({ $isDarkModeOn }) =>
    $isDarkModeOn && 'background-color: var(--color-base-1);'}
`;

const StyledPlusCourseCardDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--color-base-1);
  text-align: left;
  padding: ${Spacings.SPACING_4B};
`;

const CourseCard = ({ className }) => {
  const isDarkModeOn = useDarkModeStatus(getIsDarkModeOn);
  return (
    <StyledPlusCourseCard className={className}>
      <StyledSkeleton
        variant="rect"
        width={272}
        height={153}
        className="thumbnail"
        $isDarkModeOn={isDarkModeOn}
      />
      <StyledPlusCourseCardDetails>
        <StyledSkeleton height={22} width="20%" style={{ marginBottom: 8 }} />
        <StyledSkeleton height={20} width="100%" style={{ marginBottom: 8 }} />
        <StyledSkeleton height={20} width="30%" style={{ marginBottom: 8 }} />
        <StyledSkeleton height={12} width="70%" style={{ marginBottom: 16 }} />
        <StyledSkeleton height={18} width="40%" />
      </StyledPlusCourseCardDetails>
    </StyledPlusCourseCard>
  );
};

CourseCard.propTypes = {
  className: PropTypes.string
};

CourseCard.defaultProps = {
  className: ''
};

export default CourseCard;
